import { SolanaWithSignerBaseCommand } from '../../../solana';

import { SwitchboardSecrets } from '@switchboard-xyz/common';

export default class PrintSecrets extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description =
    'print the list of user secrets along with their whitelisted MrEnclaves';

  static examples = [''];

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
  };

  async run() {
    // const { args, flags } = await this.parse(
    //   this.constructor as typeof PrintSecrets
    // );

    const sbSecrets = new SwitchboardSecrets();

    const secrets = await sbSecrets.getUserSecrets(
      this.keypair!.publicKey.toBase58(),
      'ed25519'
    );

    this.log(JSON.stringify(secrets, undefined, 2));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to print user secrets secret');
  }
}
